module.exports = __webpack_public_path__ + "static/img/2.6a3b930.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/6/zh/2.png
// module id = d1p6
// module chunks = 0